import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["size", "disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    ref: "el",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
    class: "number-field",
    type: "text",
    inputmode: "decimal",
    autocomplete: "off",
    size: Math.max(3, _ctx.draft.length),
    disabled: _ctx.disabled,
    "aria-label": _ctx.ariaLabel,
    onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
    onKeydown: [
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.commitAndBlur && _ctx.commitAndBlur(...args)), ["prevent"]), ["enter"])),
      _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelAndBlur && _ctx.cancelAndBlur(...args)), ["prevent"]), ["esc"]))
    ]
  }, null, 40, _hoisted_1)), [
    [_vModelText, _ctx.draft]
  ])
}